import { DISABLE_STORE_CHANGE_DIALOG } from 'features/store/constants';

import type { TypographyProps } from 'components/ui';
import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';

interface Props extends TypographyProps {
  marginBottom?: TypographyProps['mb'];
  marginTop?: TypographyProps['mt'];
  marginX?: TypographyProps['mx'];
}

export const StoreChangeDisclaimer = ({
  marginBottom,
  marginTop,
  marginX,
  mb = marginBottom,
  mt = marginTop,
  mx = marginX,
  ...props
}: Props) => {
  if (DISABLE_STORE_CHANGE_DIALOG) {
    return (
      <Typography fontSize="xs" mb={mb} mt={mt} mx={mx} {...props}>
        {t('changingYourStoreDisclaimer')}
      </Typography>
    );
  }
  return null;
};
